import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NameValueDto } from '@ig-core/interfaces/name-value-dto';
import { ReferenceCodeService } from '@app/admin/reference-code/reference-code.service';
import { ApplicationService } from '@app/applications/application.service';
import { Applicant, Collateral, ColletralDetails } from './collateral-details.model';
import { LoanApplication, ApplicationAccessSpecifier } from '@app/applications/applications.model';
import { Address } from '../../applicant/applicantAddress/applicant-address.model';
import { ReferenceCode } from '@app/admin/reference-code/reference-code.model';
import { ValidationService } from '../../../application-validators/validation.service'
import { MatSnackBar } from '@angular/material';
import { ConfirmationDialogService } from '@app/utils/confirmation-dialog/confirmation-dialog.service';
import { FileUploadService } from '@app/utils/file-upload/file-upload.service';
import { File, Folder, FolderFilesComposite } from '@app/applications/application-details/loanInformation/loan-folder-files/loan-folder-files.model';
import * as fileSaver from 'file-saver';
import { ImagePreviewDialogService } from '@app/utils/image-preview-dialog/image-preview-dialog.service';
import { IgFileService } from '@ig-core/form/igFile.service';
import { DateFormatPipe } from '@app/utils/date-format.pipe';
import { SecureStorageService } from '@ig-core/authentication/secureStorage.service';
import { CAM_GEOLOCATION_EDIT } from '@app/constants/data.constants';
@Component({
  selector: 'eng-collateral-details',
  templateUrl: 'collateral-details.template.html',
  styleUrls: ['../../application-details.styles.scss', './collateral-details.scss']
})
export class CollateralDetailsComponent implements OnInit {

  @Input()
  application: LoanApplication;
  @Input()
  menuCode: string;

  colletralDetails: ColletralDetails[];
  applicants: Applicant[];
  collateral: Collateral;
  address: Address;
  collateralApplicantsList: NameValueDto[] = [];
  selectedCollateral: ColletralDetails;
  collatrelDetailsForm: FormGroup;
  applicantsForm: FormGroup;
  collateralTypes: ReferenceCode[] = [];
  collateralUses: NameValueDto[];
  maxLtv: ReferenceCode[];

  showForm: boolean;
  isFormDisabled: boolean;
  someFormDisable: boolean;
  allowAccess: boolean;
  menuItemAllowAccess: boolean;
  isCollateralFinalized: boolean;

  allFilesInFolder: FolderFilesComposite;

  applicationAccessSpecifiers: ApplicationAccessSpecifier[];
  menuItemAccessSpecifier: ApplicationAccessSpecifier;
  constitutions: NameValueDto[];
  decisionType: NameValueDto[];
  propertyDocTypes: NameValueDto[];
  propertyStatuses: NameValueDto[];
  feedbackType: NameValueDto[];
  roofTypes: NameValueDto[];
  // maxDate variable is used for not showing future date
  maxDate: Date;
  loginUser: any;
  constructor(private formBuilder: FormBuilder,
    private referenceCodeService: ReferenceCodeService,
    private applicationService: ApplicationService,
    private _snackbar: MatSnackBar,
    private fileUploadService: FileUploadService,
    private imagePreviewDialogService: ImagePreviewDialogService,
    private confirmationDialogService: ConfirmationDialogService,
    private validationService: ValidationService,
    private fileService: IgFileService,
    private customDatepipe: DateFormatPipe,
    private secureStorageService: SecureStorageService) {
    this.collatrelDetailsForm = this.formBuilder.group({
      collateralType: '',
      collateralUse: '',
      firstLine: '',
      secondLine: '',
      thirdLine: '',
      ownedBy: '',
      landArea: '',
      landValuePerSqFt: '',
      buildingValuePerSqFt: '',
      fairMarketValueOfLand: '',
      fairMarketValueOfBuilding: '',
      buildingArea: '',
      distanceFromBranch: '',
      maxLtv: '',
      ltvMarketValue: '',
      occupiedBy: '',
      buildingAge: '',

      eastBoundaryAsPerDoc: '',
      westBoundaryAsPerDoc: '',
      southBoundaryAsPerDoc: '',
      northBoundaryAsPerDoc: '',
      eastBoundaryAsVerified: '',
      westBoundaryAsVerified: '',
      southBoundaryAsVerified: '',
      northBoundaryAsVerified: '',
      eastLengthAsPerDoc: '',
      westLengthAsPerDoc: '',
      southLengthAsPerDoc: '',
      northLengthAsPerDoc: '',
      eastLengthAsVerified: '',
      westLengthAsVerified: '',
      southLengthAsVerified: '',
      northLengthAsVerified: '',
      boundaryMismatchDetails: '',
      measurementMismatchDetails: '',
      dateOfVisit: [null],
      visitedBy: '',
      technicalValuationValue: '',
      proposedLoanValue: '',
      pdDetailsGroup: this.formBuilder.group({
        loanProposed: '',
        latitude: '',
        longitude: '',
        ownershipType: '',
        documentSeen: '',
        documentNumber: '',
        documentYear: [null],
        sfNoVerified: '',
        ebNumber: '',
        documentType: '',
        parentDocumentVerified: '',
        parentDocumentNumber: '',
        parentDocumentYear: [null],
        documentFlowYear: '',
        ecVerified: '',
        ecYearFromTo: '',
        pattaChittaAvailable: '',
        propertyStatus: '',
        constructionStagePercentage: '',
        constructionLevel: '',
        occupancyStatus: '',
        propertyAreaType: '',
        buildingType: '',
      })

    });
    this.allowAccess = this.applicationService.allowAccess;
    this.maxDate = new Date();
  }

  ngOnInit() {
    this.loginUser = this.secureStorageService.secureSessionStorage.getItem("logInUserDetails")
    this.isFormDisabled = true;
    this.refreshApplicationData();
    this.fetchApplicants();

    this.getMenuItemAccess();
    this.getCollateralStatus();

  }

  getRefCodes() {
    //it is possible that we may restrict that -prop must be present 
    let collateralSet = this.application.collateralSet
    this.referenceCodeService.getRefCodesForClassifier(collateralSet).subscribe((response: any) => {
      this.collateralTypes = response;
      this.applyValidatorsToCollateralDetails();
    });

    this.referenceCodeService.getShortRefCodes('collateral_usedfor').subscribe((response: any) => {
      this.collateralUses = response.collateral_usedfor;
    });

    this.referenceCodeService.getShortRefCodes('constitution').subscribe((response: any) => {
      this.constitutions = response.constitution;
    });

    this.referenceCodeService.getShortRefCodes('yes_no').subscribe((response: any) => {
      this.decisionType = response.yes_no;
    });

    this.referenceCodeService.getShortRefCodes('property_document_type').subscribe((response: any) => {
      this.propertyDocTypes = response.property_document_type;
    });

    this.referenceCodeService.getShortRefCodes('property_status').subscribe((response: any) => {
      this.propertyStatuses = response.property_status;
    });

    this.referenceCodeService.getShortRefCodes('positive_negative').subscribe((response: any) => {
      this.feedbackType = response.positive_negative;
    });

    this.referenceCodeService.getShortRefCodes('residence_roof_type').subscribe((response: any) => {
      this.roofTypes = response.residence_roof_type;
    });
  }

  fetchCollateralDetails() {
    this.showForm = false;
    this.applicationService.getCollateralDetails(this.application.uid).subscribe((response: any) => {
      if (response) {
        this.colletralDetails = response;

        this.colletralDetails.forEach((element, index) => {
          this.colletralDetails[index]["deleteBtnDisabled"] = true
          let CheckType = this.collateralTypes.filter(object => { return object.code == element.collateral.collateralType })
          if (CheckType.length == 0 && this.collateralTypes.length != 0) {
            this.colletralDetails[index]["showInRed"] = true
          }
        });
        this.showForm = (this.colletralDetails && this.colletralDetails.length > 0);
        this.buildCollateralDetailsForm();
        this.proposedLoanCalculation();
      }
    })
  }

  fetchApplicants() {
    this.showForm = false;
    this.applicationService.getApplicants(this.application.uid).subscribe((response: any) => {
      if (response) {
        this.applicants = response;
        this.collateralApplicants();
      }
    })
  }

  collateralApplicants() {
    this.applicants.forEach((applicantsObject) => {
      let applicant = { code: applicantsObject.uid, name: applicantsObject.name + '  ' + '(' + applicantsObject.play + ')' }
      this.collateralApplicantsList.push(<NameValueDto>applicant);
    })
  }

  proposedLoanCalculation() {
    let proposedLoanToValue;

    if (this.collatrelDetailsForm.get('pdDetailsGroup')['controls']['loanProposed'].value &&
      this.collatrelDetailsForm.controls.technicalValuationValue.value !== null) {
      let loanProposedValue = this.collatrelDetailsForm.get('pdDetailsGroup')['controls']['loanProposed'].value
      let technicalValuation = this.collatrelDetailsForm.controls.technicalValuationValue.value
      proposedLoanToValue = ((loanProposedValue / technicalValuation * 100).toFixed(2));
      if (proposedLoanToValue != "Infinity") {
        this.collatrelDetailsForm.patchValue({ proposedLoanValue: proposedLoanToValue })
      } else {
        this.collatrelDetailsForm.patchValue({ proposedLoanValue: 0 })
      }
    } else {
      this.collatrelDetailsForm.patchValue({ proposedLoanValue: '' })
    }
  }


  updateMaxLTV() {
    if (this.collatrelDetailsForm.controls['collateralType'].value) {
      let selectedCollateral = this.getCollateralTypeByCode(this.collatrelDetailsForm.controls['collateralType'].value)
      if (selectedCollateral) {
        this.collatrelDetailsForm.patchValue({ maxLtv: selectedCollateral.field1 });
        this.basedOnProductTypeDisableFields();
      }
    } else {
      this.collatrelDetailsForm.patchValue({ maxLtv: '' });
    }
  }

  addNewCollateral() {
    //if (this.isFormDisabled) {
    let collateralDetails = new ColletralDetails();
    collateralDetails.address = new Address();
    collateralDetails.collateral = new Collateral();
    this.collatrelDetailsForm.enable()
    this.collatrelDetailsForm.controls.maxLtv.disable();
    this.collatrelDetailsForm.controls.ltvMarketValue.disable();
    this.collatrelDetailsForm.controls.fairMarketValueOfLand.disable();
    this.collatrelDetailsForm.controls.fairMarketValueOfBuilding.disable();
    this.collatrelDetailsForm.controls.technicalValuationValue.disable()
    this.collatrelDetailsForm.get("pdDetailsGroup")["controls"].loanProposed.disable()
    this.collatrelDetailsForm.controls.proposedLoanValue.disable()
    this.isFormDisabled = false;
    this.changeSelectedCollateral(collateralDetails, undefined, "new");
    //s}

  }

  changeSelectedCollateral(collateraldetails?: ColletralDetails, index?: number, from?: string) {
    this.showForm = true;
    this.colletralDetails.forEach((element, i) => {
      this.colletralDetails[i].deleteBtnDisabled = true
    });


    this.buildCollateralDetailsForm(collateraldetails)
    this.proposedLoanCalculation()
    this.basedOnProductTypeDisableFields(from);

    if (from != "new") {
      this.colletralDetails[index].deleteBtnDisabled = false
      this.collatrelDetailsForm.disable();
    }
  }

  buildCollateralDetailsForm(collaterals?: ColletralDetails) {
    if (this.showForm) {

      if (!collaterals) {
        collaterals = this.colletralDetails[0];
        this.colletralDetails[0].deleteBtnDisabled = false
      }
      this.collatrelDetailsForm.patchValue({
        collateralType: collaterals.collateral.collateralType,
        collateralUse: collaterals.collateral.collateralUse,
        firstLine: collaterals.address === null ? '' : collaterals.address.line1,
        secondLine: collaterals.address === null ? '' : collaterals.address.line2,
        thirdLine: collaterals.address === null ? '' : collaterals.address.line3,
        ownedBy: collaterals.collateral.ownedByUid,
        landArea: collaterals.collateral.landArea,
        landValuePerSqFt: collaterals.collateral.additionalCollateralDetails && collaterals.collateral.additionalCollateralDetails.landValuePerSqFt !== undefined
          ? collaterals.collateral.additionalCollateralDetails.landValuePerSqFt
          : null,
        buildingValuePerSqFt: collaterals.collateral.additionalCollateralDetails && collaterals.collateral.additionalCollateralDetails.buildingValuePerSqFt !== undefined
          ? collaterals.collateral.additionalCollateralDetails.buildingValuePerSqFt
          : null,
        fairMarketValueOfLand: collaterals.collateral.fairMarketValueOfLand ? collaterals.collateral.fairMarketValueOfLand : 0,
        fairMarketValueOfBuilding: collaterals.collateral.additionalCollateralDetails && collaterals.collateral.additionalCollateralDetails.fairMarketValueOfBuilding !== undefined
          ? collaterals.collateral.additionalCollateralDetails.fairMarketValueOfBuilding
          : 0,
        buildingArea: collaterals.collateral.buildingArea,
        distanceFromBranch: collaterals.collateral.distance,
        ltvMarketValue: collaterals.collateral.ltvApplied,
        occupiedBy: collaterals.collateral.additionalCollateralDetails && collaterals.collateral.additionalCollateralDetails.occupiedBy !== undefined
          ? collaterals.collateral.additionalCollateralDetails.occupiedBy
          : null,
        buildingAge: collaterals.collateral.additionalCollateralDetails && collaterals.collateral.additionalCollateralDetails.buildingAge !== undefined
          ? collaterals.collateral.additionalCollateralDetails.buildingAge
          : null,
        eastBoundaryAsPerDoc: collaterals.collateral.additionalCollateralDetails && collaterals.collateral.additionalCollateralDetails.eastBoundaryAsPerDoc !== undefined ? collaterals.collateral.additionalCollateralDetails.eastBoundaryAsPerDoc : null,

        westBoundaryAsPerDoc:
          collaterals.collateral.additionalCollateralDetails && collaterals.collateral.additionalCollateralDetails.westBoundaryAsPerDoc !== undefined
            ? collaterals.collateral.additionalCollateralDetails.westBoundaryAsPerDoc
            : null,

        southBoundaryAsPerDoc:
          collaterals.collateral.additionalCollateralDetails && collaterals.collateral.additionalCollateralDetails.southBoundaryAsPerDoc !== undefined
            ? collaterals.collateral.additionalCollateralDetails.southBoundaryAsPerDoc
            : null,

        northBoundaryAsPerDoc:
          collaterals.collateral.additionalCollateralDetails && collaterals.collateral.additionalCollateralDetails.northBoundaryAsPerDoc !== undefined
            ? collaterals.collateral.additionalCollateralDetails.northBoundaryAsPerDoc
            : null,

        eastBoundaryAsVerified:
          collaterals.collateral.additionalCollateralDetails && collaterals.collateral.additionalCollateralDetails.eastBoundaryAsVerified !== undefined
            ? collaterals.collateral.additionalCollateralDetails.eastBoundaryAsVerified
            : null,

        westBoundaryAsVerified:
          collaterals.collateral.additionalCollateralDetails && collaterals.collateral.additionalCollateralDetails.westBoundaryAsVerified !== undefined
            ? collaterals.collateral.additionalCollateralDetails.westBoundaryAsVerified
            : null,

        southBoundaryAsVerified:
          collaterals.collateral.additionalCollateralDetails && collaterals.collateral.additionalCollateralDetails.southBoundaryAsVerified !== undefined
            ? collaterals.collateral.additionalCollateralDetails.southBoundaryAsVerified
            : null,

        northBoundaryAsVerified:
          collaterals.collateral.additionalCollateralDetails && collaterals.collateral.additionalCollateralDetails.northBoundaryAsVerified !== undefined
            ? collaterals.collateral.additionalCollateralDetails.northBoundaryAsVerified
            : null,

        eastLengthAsPerDoc:
          collaterals.collateral.additionalCollateralDetails && collaterals.collateral.additionalCollateralDetails.eastLengthAsPerDoc !== undefined
            ? collaterals.collateral.additionalCollateralDetails.eastLengthAsPerDoc
            : null,

        westLengthAsPerDoc:
          collaterals.collateral.additionalCollateralDetails && collaterals.collateral.additionalCollateralDetails.westLengthAsPerDoc !== undefined
            ? collaterals.collateral.additionalCollateralDetails.westLengthAsPerDoc
            : null,

        southLengthAsPerDoc:
          collaterals.collateral.additionalCollateralDetails && collaterals.collateral.additionalCollateralDetails.southLengthAsPerDoc !== undefined
            ? collaterals.collateral.additionalCollateralDetails.southLengthAsPerDoc
            : null,

        northLengthAsPerDoc:
          collaterals.collateral.additionalCollateralDetails && collaterals.collateral.additionalCollateralDetails.northLengthAsPerDoc !== undefined
            ? collaterals.collateral.additionalCollateralDetails.northLengthAsPerDoc
            : null,

        eastLengthAsVerified:
          collaterals.collateral.additionalCollateralDetails && collaterals.collateral.additionalCollateralDetails.eastLengthAsVerified !== undefined
            ? collaterals.collateral.additionalCollateralDetails.eastLengthAsVerified
            : null,

        westLengthAsVerified:
          collaterals.collateral.additionalCollateralDetails && collaterals.collateral.additionalCollateralDetails.westLengthAsVerified !== undefined
            ? collaterals.collateral.additionalCollateralDetails.westLengthAsVerified
            : null,

        southLengthAsVerified:
          collaterals.collateral.additionalCollateralDetails && collaterals.collateral.additionalCollateralDetails.southLengthAsVerified !== undefined
            ? collaterals.collateral.additionalCollateralDetails.southLengthAsVerified
            : null,

        northLengthAsVerified:
          collaterals.collateral.additionalCollateralDetails && collaterals.collateral.additionalCollateralDetails.northLengthAsVerified !== undefined
            ? collaterals.collateral.additionalCollateralDetails.northLengthAsVerified
            : null,
        boundaryMismatchDetails:
          collaterals.collateral.additionalCollateralDetails && collaterals.collateral.additionalCollateralDetails.boundaryMismatchDetails !== undefined
            ? collaterals.collateral.additionalCollateralDetails.boundaryMismatchDetails
            : null,
        measurementMismatchDetails:
          collaterals.collateral.additionalCollateralDetails && collaterals.collateral.additionalCollateralDetails.measurementMismatchDetails !== undefined
            ? collaterals.collateral.additionalCollateralDetails.measurementMismatchDetails
            : null,
        dateOfVisit:
          collaterals.collateral.additionalCollateralDetails && collaterals.collateral.additionalCollateralDetails.dateOfVisit ? new Date(collaterals.collateral.additionalCollateralDetails.dateOfVisit)
            : null,
        visitedBy: collaterals.collateral.visitedBy,
        technicalValuationValue: collaterals.collateral.evalMarketValue,
      });
      this.collatrelDetailsForm.controls.pdDetailsGroup.patchValue({
        loanProposed: this.application.amountProp,
        latitude: collaterals.collateral.latitude && collaterals.collateral.latitude !== undefined ? collaterals.collateral.latitude : null,
        longitude: collaterals.collateral.longitude && collaterals.collateral.longitude !== undefined ? collaterals.collateral.longitude : null,
        ownershipType:
          collaterals.collateral.additionalCollateralDetails && collaterals.collateral.additionalCollateralDetails.ownershipType !== undefined
            ? collaterals.collateral.additionalCollateralDetails.ownershipType
            : null,

        documentSeen:
          collaterals.collateral.additionalCollateralDetails && collaterals.collateral.additionalCollateralDetails.documentSeen !== undefined
            ? collaterals.collateral.additionalCollateralDetails.documentSeen
            : null,

        documentNumber:
          collaterals.collateral.additionalCollateralDetails && collaterals.collateral.additionalCollateralDetails.documentNumber !== undefined
            ? collaterals.collateral.additionalCollateralDetails.documentNumber
            : null,

        documentYear:
          collaterals.collateral.additionalCollateralDetails && collaterals.collateral.additionalCollateralDetails.documentYear ? new Date(collaterals.collateral.additionalCollateralDetails.documentYear)
            : null,

        sfNoVerified:
          collaterals.collateral.additionalCollateralDetails && collaterals.collateral.additionalCollateralDetails.sfNoVerified !== undefined
            ? collaterals.collateral.additionalCollateralDetails.sfNoVerified
            : null,

        ebNumber:
          collaterals.collateral.additionalCollateralDetails && collaterals.collateral.additionalCollateralDetails.ebNumber !== undefined
            ? collaterals.collateral.additionalCollateralDetails.ebNumber
            : null,

        documentType:
          collaterals.collateral.additionalCollateralDetails && collaterals.collateral.additionalCollateralDetails.documentType !== undefined
            ? collaterals.collateral.additionalCollateralDetails.documentType
            : null,

        parentDocumentVerified:
          collaterals.collateral.additionalCollateralDetails && collaterals.collateral.additionalCollateralDetails.parentDocumentVerified !== undefined
            ? collaterals.collateral.additionalCollateralDetails.parentDocumentVerified
            : null,

        parentDocumentNumber:
          collaterals.collateral.additionalCollateralDetails && collaterals.collateral.additionalCollateralDetails.parentDocumentNumber !== undefined
            ? collaterals.collateral.additionalCollateralDetails.parentDocumentNumber
            : null,

        parentDocumentYear:
          collaterals.collateral.additionalCollateralDetails && collaterals.collateral.additionalCollateralDetails.parentDocumentYear ? new Date(collaterals.collateral.additionalCollateralDetails.parentDocumentYear)
            : null,

        documentFlowYear:
          collaterals.collateral.additionalCollateralDetails && collaterals.collateral.additionalCollateralDetails.documentFlowYear ? new Date(collaterals.collateral.additionalCollateralDetails.documentFlowYear)
            : null,

        ecVerified:
          collaterals.collateral.additionalCollateralDetails && collaterals.collateral.additionalCollateralDetails.ecVerified !== undefined
            ? collaterals.collateral.additionalCollateralDetails.ecVerified
            : null,

        ecYearFromTo:
          collaterals.collateral.additionalCollateralDetails && collaterals.collateral.additionalCollateralDetails.ecYearFromTo ? collaterals.collateral.additionalCollateralDetails.ecYearFromTo
            : null,

        pattaChittaAvailable:
          collaterals.collateral.additionalCollateralDetails && collaterals.collateral.additionalCollateralDetails.pattaChittaAvailable !== undefined
            ? collaterals.collateral.additionalCollateralDetails.pattaChittaAvailable
            : null,

        propertyStatus:
          collaterals.collateral.additionalCollateralDetails && collaterals.collateral.additionalCollateralDetails.propertyStatus !== undefined
            ? collaterals.collateral.additionalCollateralDetails.propertyStatus
            : null,

        constructionStagePercentage:
          collaterals.collateral.additionalCollateralDetails && collaterals.collateral.additionalCollateralDetails.constructionStagePercentage !== undefined
            ? collaterals.collateral.additionalCollateralDetails.constructionStagePercentage
            : null,

        constructionLevel:
          collaterals.collateral.additionalCollateralDetails && collaterals.collateral.additionalCollateralDetails.constructionLevel !== undefined
            ? collaterals.collateral.additionalCollateralDetails.constructionLevel
            : null,

        occupancyStatus:
          collaterals.collateral.additionalCollateralDetails && collaterals.collateral.additionalCollateralDetails.occupancyStatus !== undefined
            ? collaterals.collateral.additionalCollateralDetails.occupancyStatus
            : null,

        propertyAreaType:
          collaterals.collateral.additionalCollateralDetails && collaterals.collateral.additionalCollateralDetails.propertyAreaType !== undefined
            ? collaterals.collateral.additionalCollateralDetails.propertyAreaType
            : null,

        buildingType:
          collaterals.collateral.additionalCollateralDetails && collaterals.collateral.additionalCollateralDetails.buildingType !== undefined
            ? collaterals.collateral.additionalCollateralDetails.buildingType
            : null,
      })
      this.selectedCollateral = collaterals;
      this.updateMaxLTV();
      if (collaterals.collateral.collateralType != undefined) {
        this.collatrelDetailsForm.disable();
      }
      this.getSelectedFolderFiles(this.selectedCollateral.collateral.fileFolderUid);
    }
  }


  saveCollateralDetails() {
    this.validationService.markFormGroupTouched(this.collatrelDetailsForm)
    if (!this.isFormDisabled && this.collatrelDetailsForm.valid) {
      if (!this.selectedCollateral.collateral.uid) {
        this.selectedCollateral.collateral.contextUid = this.application.uid;
        this.selectedCollateral.collateral.contextType = 'application';
      }
      let collatrelDetailsFormFields = this.collatrelDetailsForm.controls;
      this.selectedCollateral.collateral.collateralType = collatrelDetailsFormFields.collateralType.value;
      this.selectedCollateral.collateral.collateralUse = collatrelDetailsFormFields.collateralUse.value;
      this.selectedCollateral.address = new Address()
      this.selectedCollateral.address.line1 = collatrelDetailsFormFields.firstLine.value;
      this.selectedCollateral.address.line2 = collatrelDetailsFormFields.secondLine.value;
      this.selectedCollateral.address.line3 = collatrelDetailsFormFields.thirdLine.value;
      this.selectedCollateral.collateral.ownedByUid = collatrelDetailsFormFields.ownedBy.value;
      this.selectedCollateral.collateral.landArea = collatrelDetailsFormFields.landArea.value;
      this.selectedCollateral.collateral.buildingArea = collatrelDetailsFormFields.buildingArea.value;
      this.selectedCollateral.collateral.distance = collatrelDetailsFormFields.distanceFromBranch.value;
      this.selectedCollateral.collateral.fairMarketValueOfLand = collatrelDetailsFormFields.fairMarketValueOfLand.value;
      this.selectedCollateral.collateral.maxLtv = collatrelDetailsFormFields.maxLtv.value;
      this.selectedCollateral.collateral.ltvApplied = collatrelDetailsFormFields.ltvMarketValue.value;
      this.selectedCollateral.collateral.visitedBy = collatrelDetailsFormFields.visitedBy.value;
      this.selectedCollateral.collateral.latitude = this.collatrelDetailsForm.getRawValue().pdDetailsGroup.latitude;
      this.selectedCollateral.collateral.longitude = this.collatrelDetailsForm.getRawValue().pdDetailsGroup.longitude;
      if (!this.selectedCollateral.collateral.additionalCollateralDetails) {
        this.selectedCollateral.collateral.additionalCollateralDetails = {};
      }
      this.selectedCollateral.collateral.additionalCollateralDetails.occupiedBy = collatrelDetailsFormFields.occupiedBy.value;
      this.selectedCollateral.collateral.additionalCollateralDetails.buildingAge = collatrelDetailsFormFields.buildingAge.value;
      this.selectedCollateral.collateral.additionalCollateralDetails.landValuePerSqFt = collatrelDetailsFormFields.landValuePerSqFt.value;
      this.selectedCollateral.collateral.additionalCollateralDetails.buildingValuePerSqFt = collatrelDetailsFormFields.buildingValuePerSqFt.value;
      this.selectedCollateral.collateral.additionalCollateralDetails.fairMarketValueOfBuilding = collatrelDetailsFormFields.fairMarketValueOfBuilding.value;
      this.selectedCollateral.collateral.additionalCollateralDetails.eastBoundaryAsPerDoc = collatrelDetailsFormFields.eastBoundaryAsPerDoc.value;
      this.selectedCollateral.collateral.additionalCollateralDetails.westBoundaryAsPerDoc = collatrelDetailsFormFields.westBoundaryAsPerDoc.value;
      this.selectedCollateral.collateral.additionalCollateralDetails.southBoundaryAsPerDoc = collatrelDetailsFormFields.southBoundaryAsPerDoc.value;
      this.selectedCollateral.collateral.additionalCollateralDetails.northBoundaryAsPerDoc = collatrelDetailsFormFields.northBoundaryAsPerDoc.value;
      this.selectedCollateral.collateral.additionalCollateralDetails.eastBoundaryAsVerified = collatrelDetailsFormFields.eastBoundaryAsVerified.value;
      this.selectedCollateral.collateral.additionalCollateralDetails.westBoundaryAsVerified = collatrelDetailsFormFields.westBoundaryAsVerified.value;
      this.selectedCollateral.collateral.additionalCollateralDetails.southBoundaryAsVerified = collatrelDetailsFormFields.southBoundaryAsVerified.value;
      this.selectedCollateral.collateral.additionalCollateralDetails.northBoundaryAsVerified = collatrelDetailsFormFields.northBoundaryAsVerified.value;
      this.selectedCollateral.collateral.additionalCollateralDetails.eastLengthAsPerDoc = collatrelDetailsFormFields.eastLengthAsPerDoc.value;
      this.selectedCollateral.collateral.additionalCollateralDetails.westLengthAsPerDoc = collatrelDetailsFormFields.westLengthAsPerDoc.value;
      this.selectedCollateral.collateral.additionalCollateralDetails.southLengthAsPerDoc = collatrelDetailsFormFields.southLengthAsPerDoc.value;
      this.selectedCollateral.collateral.additionalCollateralDetails.northLengthAsPerDoc = collatrelDetailsFormFields.northLengthAsPerDoc.value;
      this.selectedCollateral.collateral.additionalCollateralDetails.eastLengthAsVerified = collatrelDetailsFormFields.eastLengthAsVerified.value;
      this.selectedCollateral.collateral.additionalCollateralDetails.westLengthAsVerified = collatrelDetailsFormFields.westLengthAsVerified.value;
      this.selectedCollateral.collateral.additionalCollateralDetails.southLengthAsVerified = collatrelDetailsFormFields.southLengthAsVerified.value;
      this.selectedCollateral.collateral.additionalCollateralDetails.northLengthAsVerified = collatrelDetailsFormFields.northLengthAsVerified.value;
      this.selectedCollateral.collateral.additionalCollateralDetails.boundaryMismatchDetails = collatrelDetailsFormFields.boundaryMismatchDetails.value;
      this.selectedCollateral.collateral.additionalCollateralDetails.measurementMismatchDetails = collatrelDetailsFormFields.measurementMismatchDetails.value;
      this.selectedCollateral.collateral.additionalCollateralDetails.dateOfVisit = this.customDatepipe.transform(collatrelDetailsFormFields.dateOfVisit.value, 'ISODATE');
      this.selectedCollateral.collateral.additionalCollateralDetails.ownershipType = this.collatrelDetailsForm.get("pdDetailsGroup")["controls"].ownershipType.value;
      this.selectedCollateral.collateral.additionalCollateralDetails.documentSeen = this.collatrelDetailsForm.get("pdDetailsGroup")["controls"].documentSeen.value;
      this.selectedCollateral.collateral.additionalCollateralDetails.documentNumber = this.collatrelDetailsForm.get("pdDetailsGroup")["controls"].documentNumber.value;
      this.selectedCollateral.collateral.additionalCollateralDetails.documentYear = this.customDatepipe.transform(this.collatrelDetailsForm.get("pdDetailsGroup")["controls"].documentYear.value, 'ISODATE');
      this.selectedCollateral.collateral.additionalCollateralDetails.sfNoVerified = this.collatrelDetailsForm.get("pdDetailsGroup")["controls"].sfNoVerified.value;
      this.selectedCollateral.collateral.additionalCollateralDetails.ebNumber = this.collatrelDetailsForm.get("pdDetailsGroup")["controls"].ebNumber.value;
      this.selectedCollateral.collateral.additionalCollateralDetails.documentType = this.collatrelDetailsForm.get("pdDetailsGroup")["controls"].documentType.value;
      this.selectedCollateral.collateral.additionalCollateralDetails.parentDocumentVerified = this.collatrelDetailsForm.get("pdDetailsGroup")["controls"].parentDocumentVerified.value;
      this.selectedCollateral.collateral.additionalCollateralDetails.parentDocumentNumber = this.collatrelDetailsForm.get("pdDetailsGroup")["controls"].parentDocumentNumber.value;
      this.selectedCollateral.collateral.additionalCollateralDetails.parentDocumentYear = this.customDatepipe.transform(this.collatrelDetailsForm.get("pdDetailsGroup")["controls"].parentDocumentYear.value, 'ISODATE');
      this.selectedCollateral.collateral.additionalCollateralDetails.documentFlowYear = this.customDatepipe.transform(this.collatrelDetailsForm.get("pdDetailsGroup")["controls"].documentFlowYear.value, 'ISODATE');
      this.selectedCollateral.collateral.additionalCollateralDetails.ecVerified = this.collatrelDetailsForm.get("pdDetailsGroup")["controls"].ecVerified.value;
      this.selectedCollateral.collateral.additionalCollateralDetails.ecYearFromTo = this.collatrelDetailsForm.get("pdDetailsGroup")["controls"].ecYearFromTo.value;
      this.selectedCollateral.collateral.additionalCollateralDetails.pattaChittaAvailable = this.collatrelDetailsForm.get("pdDetailsGroup")["controls"].pattaChittaAvailable.value;
      this.selectedCollateral.collateral.additionalCollateralDetails.propertyStatus = this.collatrelDetailsForm.get("pdDetailsGroup")["controls"].propertyStatus.value;
      this.selectedCollateral.collateral.additionalCollateralDetails.constructionStagePercentage = this.collatrelDetailsForm.get("pdDetailsGroup")["controls"].constructionStagePercentage.value;
      this.selectedCollateral.collateral.additionalCollateralDetails.constructionLevel = this.collatrelDetailsForm.get("pdDetailsGroup")["controls"].constructionLevel.value;
      this.selectedCollateral.collateral.additionalCollateralDetails.occupancyStatus = this.collatrelDetailsForm.get("pdDetailsGroup")["controls"].occupancyStatus.value;
      this.selectedCollateral.collateral.additionalCollateralDetails.propertyAreaType = this.collatrelDetailsForm.get("pdDetailsGroup")["controls"].propertyAreaType.value;
      this.selectedCollateral.collateral.additionalCollateralDetails.buildingType = this.collatrelDetailsForm.get("pdDetailsGroup")["controls"].buildingType.value;

      this.applicationService.saveCollateralDetails(this.application.uid, this.selectedCollateral.collateral.uid, this.selectedCollateral).toPromise().then(
        (_success) => {
          this._snackbar.open("Collateral updated successfully", "Close", {
            duration: 2000,
          });
          this.isFormDisabled = true
          this.fetchCollateralDetails();
        }, (failure) => {
          let errormesg = []
          errormesg.push(failure)
          this.applicationService.displayErrorMessages(errormesg);
        }
      );
    }
  }

  basedOnProductTypeDisableFields(from?: string) {
    if (from != "new") {
      this.collatrelDetailsForm.enable()
      this.collatrelDetailsForm.controls.maxLtv.disable();
      this.collatrelDetailsForm.controls.ltvMarketValue.disable();
      this.collatrelDetailsForm.controls.fairMarketValueOfLand.disable();
      this.collatrelDetailsForm.controls.fairMarketValueOfBuilding.disable();
      this.collatrelDetailsForm.controls.technicalValuationValue.disable()
      this.collatrelDetailsForm.get("pdDetailsGroup")["controls"].loanProposed.disable()
      this.collatrelDetailsForm.controls.proposedLoanValue.disable()

      let collateralTypeRefcodeDetails = this.getCollateralTypeByCode(this.collatrelDetailsForm.controls['collateralType'].value)
      if (collateralTypeRefcodeDetails) {
        if (collateralTypeRefcodeDetails.field2 === "FMVONLY") {
          this.collatrelDetailsForm.controls.collateralUse.disable();
          this.collatrelDetailsForm.controls.firstLine.disable();
          this.collatrelDetailsForm.controls.secondLine.disable();
          this.collatrelDetailsForm.controls.thirdLine.disable();
          this.collatrelDetailsForm.controls.ownedBy.disable();
          this.collatrelDetailsForm.controls.landArea.disable();
          this.collatrelDetailsForm.controls.buildingArea.disable();
          this.collatrelDetailsForm.controls.landValuePerSqFt.disable();
          this.collatrelDetailsForm.controls.buildingValuePerSqFt.disable();
          this.collatrelDetailsForm.controls.fairMarketValueOfBuilding.disable();
          this.collatrelDetailsForm.controls.distanceFromBranch.disable();
        }
      }
    } else {
      this.collatrelDetailsForm.disable();
      this.collatrelDetailsForm.controls.collateralType.enable();
    }
  }

  enableDisableForm() {
    this.colletralDetails.forEach((element, i) => {
      this.colletralDetails[i].deleteBtnDisabled = true
    });
    this.basedOnProductTypeDisableFields();
    this.isFormDisabled = false;
    if (this.isCollateralFinalized) {
      this.collatrelDetailsForm.controls.collateralType.disable()
    }
    // right now geolocation is captured in mobile app. If required in web-app then we are enabling based on authority
    const canGeolocationEdit = this.loginUser.authorities.includes(CAM_GEOLOCATION_EDIT);
    if (!canGeolocationEdit) {
      this.collatrelDetailsForm.get("pdDetailsGroup")["controls"].latitude.disable();
      this.collatrelDetailsForm.get("pdDetailsGroup")["controls"].longitude.disable();
    }
  }

  cancelForm() {
    this.colletralDetails.forEach((element, i) => {
      this.colletralDetails[i].deleteBtnDisabled = true
    });
    if (this.colletralDetails && this.colletralDetails.length > 0) {
      this.colletralDetails[0].deleteBtnDisabled = false
      this.buildCollateralDetailsForm(this.colletralDetails[0]);
    } else {
      this.showForm = false;
    }
    this.isFormDisabled = true;
    this.collatrelDetailsForm.disable();
  }
  //this function will apply validators to form group
  applyValidatorsToCollateralDetails() {
    this.validationService.applyValidationRules(this.collatrelDetailsForm, "CollateralDetails").then((controlValidators) => {
      this.fetchCollateralDetails();
      this.collatrelDetailsForm.disable();
      //this.basedOnProductTypeDisableFields();
    }).catch(() => {
    })
  }

  //this function will get either this menu item  is editable or readonly 
  getMenuItemAccess() {
    this.applicationService.getApplicationAccessModifiers(this.application.uid)
      .subscribe((response) => {
        this.applicationAccessSpecifiers = response.body;
        this.menuItemAccessSpecifier = this.applicationAccessSpecifiers
          .find(accessSpecifier => accessSpecifier.category === this.menuCode);
        if (this.menuItemAccessSpecifier) {
          this.menuItemAllowAccess = this.menuItemAccessSpecifier.allowAccess;
        }
      });
  }

  getCollateralTypeByCode(code) {
    if (this.collateralTypes.length != 0) {
      return this.collateralTypes.filter(collateralType => collateralType.code === code)[0];
    }
  }

  getCollateralStatus() {
    this.applicationService.getCollateralStatus(this.application.uid)
      .subscribe(response => {
        this.isCollateralFinalized = response.body.collateralFinalized;
      });
  }

  //this function will call to get basic application data 
  // to refresh "this.application" values after particular action eg: after decision save like proceed in sidenav
  refreshApplicationData() {
    this.applicationService.getBasicApplicationInfo(
      this.application.uid, 'ApplicationOnly').subscribe((response) => {
        this.application = response.body.applicationDTO;
        this.getRefCodes();
      });
  }

  //this function will be called on click of delete icon on collatral list
  deleteCollateral(selectedCollateral) {
    this.applicationService.collateralDelete(this.application.uid, selectedCollateral.collateral.uid).subscribe((response) => {
      if (response.body.status == "success") {
        this._snackbar.open("Collateral deleted successfully", "Close", {
          duration: 2000,
        });
        this.fetchCollateralDetails();
      } else {
        let errormesg = []
        errormesg.push("Collateral deleted failed")
        errormesg.push(response.body.message)
        this.applicationService.displayErrorMessages(errormesg);
      }
    }, (failure) => {
      let errormesg = []
      errormesg.push("Collateral deleted failed")
      errormesg.push(failure)
      this.applicationService.displayErrorMessages(errormesg);
    });
  }

  openDeleteConfirmation() {
    this.confirmationDialogService.open({ "btnCancelText": "Cancel", "btnConfirmText": "Delete", "message": "Are you sure you want to delete this collateral?" })
    this.confirmationDialogService.confirmed().subscribe(data => {
      if (data) {
        this.deleteCollateral(this.selectedCollateral)
      }
    })
  }


  //this function open up the image upload dailog box
  //if file upload should allow single and multiple file upload, we need to pass "uploadType":"multiple"
  openImageFileUploadDialog() {
    if (this.selectedCollateral.collateral != null) {
      this.fileUploadService.open({ "uploadType": "multiple", "folderUid": this.selectedCollateral.collateral.fileFolderUid, "applicationUid": this.application.uid, "files": this.allFilesInFolder.fileInfo })
      this.fileUploadService.confirmed().subscribe(data => {
        this.getSelectedFolderFiles(data.folderUid)
      })

    } else {
      this._snackbar.open("Please add a folder to upload files", "Close", {
        duration: 5000,
      });
    }
  }


  getSelectedFolderFiles(folderUid) {
    this.applicationService.getAllFilesInApplicationFolder(this.application.uid, folderUid).subscribe((response: any) => {
      if (response) {
        this.allFilesInFolder = response.body;
        this.allFilesInFolder.fileInfo.forEach(element => {
          if (element.fileSize) {
            element["convertedFileSize"] = this.applicationService.bytesToSize(element.fileSize)
          }
        });
      }
    });
  }

  //this function will call onclick of download icon in file's section
  downloadFile(file) {
    this.applicationService.downloadFileFromApplicationFolder(this.application.uid, file.folderUid, file.fileId).subscribe(image => {
      const blob = new Blob([image.data], { type: file.type });
      fileSaver.saveAs(blob, file.fileName);
      this._snackbar.open("File has been downloaded successfully", "Close", {
        duration: 5000,
      });
    })
  }

  //this function will trigger onclicking of image,will open up a mat-dailog
  openContentElement() {
    this.imagePreviewDialogService.open({ "images": this.allFilesInFolder })
  }


  openfileDeleteConfirmation(selectedFile) {
    this.confirmationDialogService.open({ "btnCancelText": "Cancel", "btnConfirmText": "Delete", "message": "Are you sure you want to delete this File?" })
    this.confirmationDialogService.confirmed().subscribe(data => {
      if (data) {
        this.deleteFile(selectedFile)
      }
    })

  }

  //this function will be called on click of delete icon on file list
  deleteFile(selectedFile) {
    this.applicationService.fileDelete(this.application.uid, selectedFile.uid).subscribe((response) => {
      if (response.body.status == "success") {
        this._snackbar.open("File deleted successfully", "Close", {
          duration: 2000,
        });
        this.getSelectedFolderFiles(this.selectedCollateral.collateral.fileFolderUid);
      } else {
        let errormesg = []
        errormesg.push("File deleted failed")
        errormesg.push(response.body.message)
        this.applicationService.displayErrorMessages(errormesg);
      }
    }, (failure) => {
      let errormesg = []
      errormesg.push("File deleted failed")
      errormesg.push(failure)
      this.applicationService.displayErrorMessages(errormesg);
    });
  }

  viewPdf(file) {
    this.fileService.fileStreamById(file.fileId, "false").subscribe(res => {
      window.open(res.data, '_blank');
    })
  }

  calculatePropertyValue() {
    const buildingArea = Number(this.collatrelDetailsForm.controls.buildingArea.value) || 0;
    const buildingRate = Number(this.collatrelDetailsForm.controls.buildingValuePerSqFt.value) || 0;

    const landArea = Number(this.collatrelDetailsForm.controls.landArea.value) || 0;
    const landRate = Number(this.collatrelDetailsForm.controls.landValuePerSqFt.value) || 0;

    let fairMarketValueOfBuilding = buildingArea * buildingRate;
    let fairMarketValueOfLand = landArea * landRate;

    this.collatrelDetailsForm.patchValue({
      fairMarketValueOfBuilding: fairMarketValueOfBuilding,
      fairMarketValueOfLand: fairMarketValueOfLand,
    }, { emitEvent: false });
  }

  openGoogleMaps() {
    const lat = this.collatrelDetailsForm.getRawValue().pdDetailsGroup.latitude;
    const lng = this.collatrelDetailsForm.getRawValue().pdDetailsGroup.longitude;

    window.open(`https://www.google.com/maps?q=${lat},${lng}`,'_blank');
  }

}